import Icon from 'components/shared/Icon/Icon';

const ContentHeader = ({ closePopover, label }) => (
  <div className="flex justify-between gap-4 bg-white px-4 py-2 shadow-[0px_2px_4px_rgba(27,33,35,0.04)]">
    <span className="text-sm font-500 leading-6">
      {label ? `Export ${label}` : 'Export Report'}
    </span>
    <button
      type="button"
      aria-label="Close export"
      onClick={closePopover}
      className="ml-auto flex size-[26px] cursor-pointer select-none items-center justify-center border-0 bg-transparent p-0">
      <Icon data-qa="close-square-mono" icon="close-linear" />
    </button>
  </div>
);

export default ContentHeader;
